import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Form, Message, Row } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ReviewSummaryResultForm from '../../components/forms/reviewSummaryForm/ReviewSummaryResultForm'
import ReviewSummaryForm from '../../components/forms/reviewSummaryForm/ReviewSummaryForm'
import { saveReviewComment, saveReviewCommentMulti } from '../../redux/actions/reviewSummary'
import { startLoading, doneLoading } from '../../utils/loading'
import ApprovedExpertListTable from '../../components/table/approvedExpertListTable/ApprovedExpertListTable'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function ReviewSummaryResultMuti({ schema, isAll = false, onComplete = () => {} }) {
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [submitData, setSubmitData] = useState()
  const dispatch = useDispatch()
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(schema)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  const handleSaveReviewSummary = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      // console.log('request', JSON.stringify(request))
      let response
      if (isAll) {
        response = await saveReviewCommentMulti(request)
      } else {
        response = await saveReviewComment(request)
      }

      // console.log('handleSaveReviewSummary response', JSON.stringify(response))
      onComplete(response)
      doneLoading()
    } catch (e) {
      console.log('Error : ', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleRequest = (data) => {
    const body = {
      groupId: projectId,
      projectVersionId: formSchema.ReviewerSummary.projectVersionId,
      background: {
        id: formSchema.ReviewerSummary?.background?.id,
        projectFeedbackId: formSchema.ReviewerSummary?.background?.projectFeedbackId,
        value: data.background,
      },
      objective: {
        id: formSchema.ReviewerSummary?.objective?.id,
        projectFeedbackId: formSchema.ReviewerSummary?.objective?.projectFeedbackId,
        value: data.objective,
      },
      periodAndPlan: {
        id: formSchema.ReviewerSummary?.periodAndPlan?.id,
        projectFeedbackId: formSchema.ReviewerSummary?.periodAndPlan?.projectFeedbackId,
        value: data.periodAndPlan,
      },
      targetGroup: {
        id: formSchema.ReviewerSummary?.targetGroup?.id,
        projectFeedbackId: formSchema.ReviewerSummary?.targetGroup?.projectFeedbackId,
        value: data.targetGroup,
      },
      budget: {
        id: formSchema.ReviewerSummary?.budget?.id,
        projectFeedbackId: formSchema.ReviewerSummary?.budget?.projectFeedbackId,
        value: data.budget,
      },
      monitoring: {
        id: formSchema.ReviewerSummary?.monitoring?.id,
        projectFeedbackId: formSchema.ReviewerSummary?.monitoring?.projectFeedbackId,
        value: data.monitoring,
      },
      expectedResult: {
        id: formSchema.ReviewerSummary?.expectedResult?.id,
        projectFeedbackId: formSchema.ReviewerSummary?.expectedResult?.projectFeedbackId,
        value: data.expectedResult,
      },
      otherComment: {
        id: formSchema.ReviewerSummary?.otherComment?.id,
        projectFeedbackId: formSchema.ReviewerSummary?.otherComment?.projectFeedbackId,
        value: data.otherComment,
      },
      reviewResult: {
        value: data.reviewResult,
      },
      // reviewerFilter: {
      //   value: data.reviewerFilter,
      // },
    }
    //console.log('request', JSON.stringify(body))
    handleSaveReviewSummary(body)
  }

  const onSubmit = (data) => {
    setSubmitData(data)
    setIsShowConfirm(true)
  }

  const onConfirm = () => {
    setIsShowConfirm(false)
    handleRequest(submitData)
  }

  const onCancle = () => {
    setIsShowConfirm(false)
  }

  return (
    <>
      {formSchema && (
        <>
          <Form fluid>
            {!isAll && (
              <>
                <Panel shaded header="รายชื่อผู้ทรงคุณวุฒิ" bordered collapsible defaultExpanded>
                  <ApprovedExpertListTable
                    data={formSchema.ReviewerApproveList?.itemsList}
                    hideRound={true}
                    hideInviteLetter={true}
                  />
                </Panel>
                <br />
              </>
            )}

            <Panel shaded header={formSchema.header} bordered collapsible defaultExpanded>
              <ReviewSummaryResultForm
                schema={formSchema.ReviewerSummary}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />

              <Panel
                // shaded
                header={formSchema.ReviewerSummary.reviewResult.label}
                // bordered
                collapsible
                defaultExpanded
              >
                <ReviewSummaryForm
                  schema={formSchema.ReviewerSummary}
                  isMulti={true}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
                <hr />
                {isError && (
                  <Row style={{ marginBottom: 10 }}>
                    <Message
                      showIcon
                      type="error"
                      description={`บันทึกความเห็นพิจารณากลั่นกรอง${
                        isAll && 'ไปยังทุกโครงการ'
                      } ผิดพลาด กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
                    />
                  </Row>
                )}
                <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}>
                  บันทึกความเห็นพิจารณากลั่นกรอง {isAll && 'ไปยังทุกโครงการ'}
                </SaveButton>
              </Panel>
            </Panel>
            <br />
          </Form>

          <ConfirmWidget
            title={`ยืนยันการบันทึก`}
            show={isShowConfirm}
            detail={`กรุณายืนยันการบันทึกความเห็นพิจารณากลั่นกรอง`}
            onCancle={onCancle}
            onConfirm={onConfirm}
          />
        </>
      )}
    </>
  )
}
